<template>
    <span class="el-form-item__description">
        {{ value ? value.length : 0 }}/{{ limit }}
    </span>
</template>

<script>
export default {
    name: 'WordCount',
    props: {
        value: {
            type: String,
            default: '',
        },
        limit: {
            type: [Number, String],
            default: 0,
        },
    },
};
</script>
